<template>
    <v-container id="nfts" :class="$vuetify.breakpoint.mobile ? '' : 'mt-4'">
        <v-overlay id="welcome-overlay" :dark="false" :value="overlay.welcome">
            <v-card max-width="640">
                <v-card-title>
                    Kudos! 🎉
                </v-card-title>
                <v-card-subtitle class="mb-4 subtitle-1">
                    You're steps away from your first BraNFT™...
                </v-card-subtitle>
                <v-card-text>
                    <p class="text-left body-1">Creating your first BraNFT™ is easy and pretty intuitive, so feel free to skip the tour and start. Just make sure that you verify your account via the email that was sent when you signed up.</p>
                    <p class="text-left body-1">After you verify your account, you will receive a secret, which you further use to verify <i>yourself</i> and which will allow you to mint your first BraNFT™</p>
                    <p class="text-left body-1">The tour walks you thru the process in more detail. Anytime you want to view it again, just click the tour button.
                    <p></p>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="tourButtonHandler" class="btn btn-primary">Start</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="() => { $router.replace($route.hash.replace(/welcome=[^&]/, '')); overlay.welcome = false }" class="btn btn-primary">Skip</v-btn>
                </v-card-actions>
            </v-card>
        </v-overlay>
        <p @click="expandParagraph" class="text-left text-body-2 text-md-body-1 font-weight-light mx-md-4" :class="$vuetify.breakpoint.mobile ? 'mobile-paragraphs' : ''">
            A BraNFT™ is a <span class="font-weight-medium">truly unique</span> digital, non-fungible asset, attached to a real-world item... a bra or brassier if you will.
            <br />
            <br />
            Each and every woman's bra is unique, not just in size, shape, color, or any other physical attribute itself, but they are also one of a kind in the wealth of stories they each have to tell. The intimate stories they share with those who were their wearers. Yes, in fact, a woman's bra is just as unique as her breasts.
            <br />
            <br />
            Down to the DNA, no two pair of breasts are the same, and likewise each BraNFT™ is a novel item to be had.
        </p>
        <div id="button-bar" class="d-flex align-center">
            <v-chip color="#43A047" dark label small v-if="wallet && wallet.isSignedIn()">
                <icon-base height="25" width="25" viewBox="0 0 180 225" icon-name="near" class="mr-2">
                    <icon-near iconColor="rgba(0, 0, 0, 1)" />
                </icon-base>
                <span v-if="!$vuetify.breakpoint.mobile" class="font-weight-dark text-uppercase mr-2" style="color: black">Near Wallet Account</span>
                <v-tooltip :disabled="!$vuetify.breakpoint.mobile" top>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on" :class="$vuetify.breakpoint.mobile ? 'wallet-account-id' : ''">{{ wallet.getAccountId() }}</span>
                    </template>
                    <span>{{ wallet.getAccountId() }}</span>
                </v-tooltip>
                <v-btn light x-small @click="walletDisconnect" class="ml-4">Disconnect</v-btn>
            </v-chip>
            <div v-if="roles.find(role => role === 'advanced')" class="d-flex align-center">
                <v-chip label small v-if="!wallet || !wallet.isSignedIn()">
                    <icon-base height="25" width="25" viewBox="0 0 180 225" icon-name="near" class="mr-2">
                        <icon-near iconColor="rgba(0, 0, 0, 1)" />
                    </icon-base>
                    <span class="font-weight-dark text-uppercase"><span v-if="!$vuetify.breakpoint.mobile">Near </span>Wallet <span v-if="!$vuetify.breakpoint.mobile">Account</span></span>
                    <v-btn light x-small @click="walletConnect" class="ml-4">Connect</v-btn>
                </v-chip>
                <v-btn text x-small @click="recoverWallet" class="ml-4 d-flex align-center">Recovery</v-btn>
            </div>
        </div>
        <v-divider class="my-6"></v-divider>
        <v-expansion-panels :class="$vuetify.breakpoint.mobile ? 'mobile mb-16' : ''" v-model="expansionPanels" multiple popout>
            <v-expansion-panel
                               :id="currentPanelComponent.id"
                               v-for="(currentPanelComponent,i) of pageComponents"
                               :key="i">
                <v-fade-transition leave-absolute>
                    <v-expansion-panel-header>
                        <template v-slot:default="{ open }">
                            <v-row class="d-flex align-center" no-gutters>
                                <v-col :cols="$vuetify.breakpoint.mobile ? 0 : 4">
                                    <v-icon :color="open ? currentPanelComponent.iconColor : ''" v-if="!$vuetify.breakpoint.mobile" class="mr-2">{{ currentPanelComponent.icon }}</v-icon>
                                    <span v-if="!$vuetify.breakpoint.mobile" class="text-uppercase font-weight-dark">{{ currentPanelComponent.name }}</span>
                                </v-col>
                                <v-col
                                       :cols="$vuetify.breakpoint.mobile ? 12 : 8"
                                       class="text--secondary">

                                    <span class="text-capitalize font-weight-medium text-h5"
                                          v-if="open"
                                          key="0">
                                        <div v-html="currentPanelComponent.prompt"></div>
                                    </span>
                                    <span class="text-capitalize font-weight-light text-h6"
                                          v-else
                                          key="1">
                                        <div v-html="currentPanelComponent.prompt"></div>
                                    </span>

                                </v-col>
                            </v-row>
                        </template>
                    </v-expansion-panel-header>
                </v-fade-transition>
                <v-expansion-panel-content>
                    <component
                               :is="currentPanelComponent.component"
                               :currentProperties="currentProperties"
                               v-on="componentEventListeners"></component>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-container>
</template>
<style scoped>
.wallet-account-id {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.v-progress-circular.v-progress-circular--visible.v-progress-circular--indeterminate {
    height: 15px !important;
    width: 15px !important;
}
</style>
<style>
.v-expansion-panel-content__wrap {
    padding: 0;
}
.mobile .v-expansion-panel--active::before {
    box-shadow: unset !important;
}
</style>
<script>
const { VUE_APP_NEAR_NFT_CONTRACT_ID } = process.env;

import { mdiCreation, mdiGold, mdiHandCoin } from "@mdi/js";
import IconB from "../components/IconB.vue";
import IconNear from "../components/IconNear.vue";
import IconBase from "../components/IconBase.vue";
import TsNftCreatePanel from "./TsNftCreatePanel.vue";
import TsNftSellPanel from "./TsNftSellPanel.vue";
import TsNftBuyPanel from "./TsNftBuyPanel.vue";

export default {
    name: "NFTs",
    components: {
        IconB,
        IconBase,
        IconNear,
        TsNftCreatePanel,
        TsNftSellPanel,
        TsNftBuyPanel,
    },
    filters: {},
    data: function () {
        return {
            mdiCreation,
            mdiGold,
            mdiHandCoin,
            componentEventListeners: {
                createdEvent: (event) => {
                    // check for the right component
                    event;
                },
            },
            pageComponents: [
                {
                    name: "Create",
                    component: TsNftCreatePanel,
                    prompt: `BraNFT™ Studio`,
                    icon: mdiCreation,
                    iconColor: "#AA00FF", // purple accent-4
                    id: "nft-create-component",
                },
                {
                    name: "Sell",
                    component: TsNftSellPanel,
                    prompt: "BraNFT™ Store",
                    icon: mdiGold,
                    iconColor: "#FFD600", // yellow accent-4
                    id: "nft-sell-component",
                },
                {
                    name: "Buy",
                    component: TsNftBuyPanel,
                    prompt: "BraNFT™ Gallery",
                    icon: mdiHandCoin,
                    iconColor: "#00C853", // green accent-4
                    id: "nft-buy-component",
                },
            ],
            wallet: null,
            overlay: {
                welcome: null,
            },
            startTour: null,
        };
    },
    computed: {
        expansionPanels: {
            get: function () {
                return this.$store.state["account.nfts.expansionPanels"];
            },
            set: function (val) {
                this.$store.commit({
                    type: "set",
                    "account.nfts.expansionPanels": val,
                });
            },
        },
        currentProperties() {
            const allChildren = {
                wallet: this.wallet,
                startTour: this.startTour,
            };
            if (
                this.expansionPanels &&
                this.expansionPanels.find((panelIndex) => panelIndex === 0)
            ) {
                return {
                    ...allChildren,
                };
            }
            return allChildren;
        },
        roles() {
            const roles = this.$auth.user
                ? this.$auth.user[`https://${tld}/roles`]
                : undefined;
            return roles ? roles : [];
        },
    },
    mounted() {
        const welcomeParam = new URLSearchParams(
            `?${document.location.hash.split("?")[1]}`
        ).get("welcome");
        this.overlay.welcome =
            welcomeParam && !localStorage.getItem(`welcome-tour`)
                ? true
                : false;
        this.$near.getWalletConnection();
        if (this.$route.hash.match(/#nft-create/) && this.$route.query.welcome)
            this.$set(this, "expansionPanels", [0]);
    },
    methods: {
        async walletConnect() {
            await this.$near.signIn();
        },
        async walletDisconnect() {
            await this.$near.signOut({ contractIds: [VUE_APP_NEAR_NFT_CONTRACT_ID] });
        },
        async recoverWallet() {
            await this.$backend.walletRecovery();
            this.$root.$emit("recoveryRequestSent");
        },
        tourButtonHandler() {
            this.overlay.welcome = false;
            this.$set(this, "startTour", true);
        },
        expandParagraph(event) {
            if (event.target.classList.contains("mobile-paragraphs"))
                event.target.classList.remove("mobile-paragraphs");
            else event.target.classList.add("mobile-paragraphs");
        },
    },
};
</script>
